import { getTimeZoneByGeoLocation } from 'async-timing';
import { AddressType } from 'application-types';

export function getBrowserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getChannelTimezone(address: AddressType): string | null {
  if (!address.geo) {
    return null;
  }

  const [longitude, latitude] = address.geo;

  return getTimeZoneByGeoLocation({ longitude, latitude });
}
